// Format a credits balance for display.
// Whole numbers render as "5"; decimals trim trailing zeros, max 2 dp ("4.75", "4.5").
export function formatCredits(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "0";
  if (Number.isInteger(value)) return String(value);
  // Two decimals max, then strip trailing zeros.
  return value.toFixed(2).replace(/\.?0+$/, "");
}
